import freeLogoIcon from '../../../../../assets/free-icon.svg';
import lightningFreeLogoIcon from '../../../../../assets/lightning-hero_free-icon.svg';
import lightningPermissionIcon from '../../../../../assets/lightning-hero_permission-icon.svg';
import lightningRegistrationIcon from '../../../../../assets/lightning-hero_registration-icon.svg';
import permissionIcon from '../../../../../assets/permission-icon.svg';
import registrationIcon from '../../../../../assets/registration-icon.svg';
import polyglot from '../../../../../localization';

import { LightningHeroBenefit } from './LightningHeroBenefit';

import './styles.scss';

/**
 * LightningHeroBenefits renders the three key benefits (free, no registration,
 * no permission). Used in LightningIntro on desktop and below the intro on
 * mobile / tablet, same as kickandboom HeroBenefits.
 *
 * @param {string} lang — Language key used to localize benefit texts and alt labels.
 */
export const LightningHeroBenefits = ({ lang }) => (
    <div className='lightning-hero-benefits'>
        <LightningHeroBenefit
            src={freeLogoIcon}
            lightningSrc={lightningFreeLogoIcon}
            alt={polyglot.t(`${lang}.hero.alt.wallet`)}
            description={polyglot.t(`${lang}.hero.free`)}
        />
        <LightningHeroBenefit
            src={registrationIcon}
            lightningSrc={lightningRegistrationIcon}
            alt={polyglot.t(`${lang}.hero.alt.human`)}
            description={polyglot.t(`${lang}.hero.noRegistration`)}
        />
        <LightningHeroBenefit
            src={permissionIcon}
            lightningSrc={lightningPermissionIcon}
            alt={polyglot.t(`${lang}.hero.alt.key`)}
            description={polyglot.t(`${lang}.hero.noPermission`)}
        />
    </div>
);
